import { COMPANY } from "@/lib/content";
import { EmailText } from "@/components/site/EmailText";
import { LogoTile } from "@/components/site/Logo";
import { Reveal } from "@/components/site/Reveal";
import { ApplicationForm } from "./ApplicationForm";
import { EEO_TEXT } from "./sections";

export const ApplicationHeader = () => (
  <div className="bg-[#154F49] text-[#FBF8F1] p-6 sm:p-10 border-b-4 border-[#CDA34F]">
    <div className="flex flex-col sm:flex-row sm:items-center gap-5">
      <LogoTile className="w-20 h-20" />
      <div>
        <span className="inline-block px-3 py-1 rounded-full bg-[#CDA34F] text-[#154F49] text-xs font-bold uppercase tracking-wider mb-2 no-print">Submit online with resume · or print / save as PDF</span>
        <p className="text-xs uppercase tracking-[0.24em] text-[#E2C372] mb-1">Application for Employment</p>
        <h2 id="application-heading" className="font-serif text-3xl sm:text-5xl">Staffing Employment Application</h2>        <p className="text-sm text-[#EDF1E6] mt-2">
          <strong>{COMPANY.name}</strong> · {COMPANY.address} · Phone: <a href={COMPANY.phoneHref} className="underline">{COMPANY.phoneDisplay}</a> · Email: <a href={`mailto:${COMPANY.email}`} className="underline" data-testid="application-email-link"><EmailText /></a>
        </p>
      </div>
    </div>
  </div>
);

export const Instructions = () => (
  <div id="app-instructions" className="px-6 sm:px-10 pt-8 space-y-3 text-sm">
    <p className="text-[#2C3B37] italic leading-relaxed border-l-2 border-[#CDA34F] pl-4" data-testid="eeo-statement">{EEO_TEXT}</p>
    <p className="text-[#1A2E2B] leading-relaxed"><strong className="text-[#154F49] uppercase tracking-wide">Instructions:</strong> Complete all sections clearly — please type or print. You may attach a resume, but you must still complete all questions — please fill out each box (don't just write "See Resume"). Enter N/A where a question does not apply. Applications with missing information may not be considered. Required fields are marked *.</p>
    <p className="text-[#465F57] no-print">
      <strong className="text-[#154F49]">Security notice:</strong> Applications are sent over HTTPS, saved in Elevion's private hiring portal and a copy is emailed to <a href={`mailto:${COMPANY.email}`} className="font-bold text-[#154F49] underline">{COMPANY.email}</a>. <strong className="text-[#154F49]">Do not enter Social Security, driver's license or work permit numbers here</strong> — HR collects them securely during onboarding. Do not upload images of ID cards, passports or medical records.
    </p>
  </div>
);

export const ApplicationSection = () => (
  <section id="apply-online" aria-labelledby="application-heading" className="py-20 sm:py-28 bg-[#EDF1E6] print-root" data-testid="application-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-10 text-center no-print">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#9B742A]">Join the network</p>
      </Reveal>
      <div className="bg-[#FBF8F1] rounded-[32px] border border-[#154F49]/20 shadow-[0_30px_80px_-40px_rgba(21,79,73,0.5)] overflow-hidden">
        <ApplicationHeader />
        <Instructions />
        <ApplicationForm />
      </div>
    </div>
  </section>
);
